export default __webpack_public_path__ + "81e7b8a263c79b89d4b5703275e6569c.png";